module.exports = __webpack_public_path__ + "img/last-section-bg-large.4c07cb7b.png";